module.exports = __webpack_public_path__ + "media/images/svg/shop_btn-c895702822fb267555a5216f6057096f.svg";